// extracted by mini-css-extract-plugin
export default {"searchBox":"searchBox--688c299","arrowDown":"arrowDown--f86cb5a","arrowUp":"arrowUp--156a4d6"};